import { EnterpriseProfileDataContext } from '@/components/elements/profile/enterprise/client/context/EnterpriseProfileDataContext';
import { ENTERPRISE_HIGHLIGHT_COURSES } from '@/constant/QueryKeyName';
import { getHighlightCoursesOfEnterpriseUser } from 'apis/tms/course.api';
import { useContext } from 'react';
import { useQuery } from 'react-query';

const useEnterpriseHighlightCourses = () => {
  const { enterpriseUserTmsId } = useContext(EnterpriseProfileDataContext);

  const queryReturn = useQuery(
    [ENTERPRISE_HIGHLIGHT_COURSES, enterpriseUserTmsId],
    () => getHighlightCoursesOfEnterpriseUser(enterpriseUserTmsId as string),
    {
      enabled: !!enterpriseUserTmsId,
      initialData: [],
    }
  );

  return { queryReturn };
};

export default useEnterpriseHighlightCourses;
